import {Component, computed, ElementRef, ViewChild, OnInit, OnDestroy} from '@angular/core';
import {AppMenu} from './app.menu';
import {LayoutService} from '@/layout/service/layout.service';
import {RouterModule} from '@angular/router';
import {AppTopbar} from "@/layout/components/app.topbar";
import {CommonModule} from "@angular/common";
import { environment } from 'src/environments/environment';
import {MessageModule} from 'primeng/message';

@Component({
    selector: '[app-sidebar]',
    standalone: true,
    imports: [CommonModule,AppMenu, RouterModule, AppTopbar, MessageModule],
    template: `
    <div *ngIf="showWelcomeMessage" class="px-3 mb-2 mt-2">
        <div class="relative w-full max-w-[1200px] mx-auto">
            <p-message severity="info" styleClass="w-full">
                <div class="flex flex-wrap gap-2 justify-center w-full pr-10">
                    <span style="font-size: 1.2rem; font-color: #000;">✨ <b>O Sigos Web está renovado!</b> Preparamos uma versão mais moderna e prática para você aproveitar.</span>

                    <a href="#" class="text-primary hover:underline font-medium flex items-center gap-1" (click)="onLearnMoreClick($event)">
                        Se preferir, você pode retornar para a versão antiga clicando aqui.
                    </a>
                </div>
            </p-message>
            <button
                type="button"
                class="p-message-close p-link absolute top-3 right-3 w-8 h-8 rounded-full flex items-center justify-center bg-transparent border-none cursor-pointer z-10 hover:bg-black/10 transition-colors"
                (click)="closeWelcomeMessage()"
                aria-label="Close">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <div class="layout-sidebar" [ngClass]="menuColor" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
        <div class="sidebar-header">
            <a class="logo" [routerLink]="['/']">
                <img  src="assets/sigos-images/logo.png" alt="sigosLogo" width="100%" />
            </a>
            <button class="layout-sidebar-anchor z-2" type="button" (click)="anchor()"></button>
        </div>
        <div class="!text-red-900 text-xl font-bold">{{textType === 'PRD' ? '' : textType}}</div>



        <div #menuContainer class="layout-menu-container">
            <div app-menu></div>
        </div>
        <div app-topbar *ngIf="isHorizontal()"></div>
    </div>`,
})

//<img class="logo-image" [src]="menuTheme() === 'light' ? '/layout/images/logo-dark.svg' : '/layout/images/logo-white.svg'" alt="diamond-layout" />
                //<span class="app-name title-h7">DIAMOND3</span>

export class AppSidebar implements OnInit, OnDestroy {

    private environmentUrl: string = '';
    public menuColor: string = '';
    public textType: string = '';
    public showWelcomeMessage: boolean = true;
    public sigosMvcUrl: string = environment.sigosMvcUrl;

    timeout: any = null;
    welcomeMessageTimer: any = null;

    isHorizontal = computed(() => this.layoutService.isHorizontal());

    menuTheme = computed(() => this.layoutService.layoutConfig().menuTheme);

    @ViewChild('menuContainer') menuContainer!: ElementRef;

    constructor(
        public layoutService: LayoutService,
        public el: ElementRef
    ) {
        this.environmentUrl = environment.ApiCore;
        if (this.environmentUrl.startsWith('https://localhost')) {
            this.menuColor = '!bg-gray-100';
            this.textType= 'LOCAL';
        }
        if (this.environmentUrl.startsWith('https://dev.')) {
            this.menuColor = '!bg-green-100';
            this.textType = 'DEV';
            this.sigosMvcUrl = environment.sigosMvcUrlDev;
        }
        if (this.environmentUrl.startsWith('https://hml.')) {
            this.menuColor = '!bg-blue-100';
            this.textType = 'HML';
            this.sigosMvcUrl = environment.sigosMvcUrlHml;
        }
        if (this.environmentUrl.startsWith('https://api.')) {
            this.textType = 'PRD';
            this.sigosMvcUrl = environment.sigosMvcUrlPrd;
        }
    }

    ngOnInit() {
        // Timer para fechar a mensagem automaticamente após 40 segundos
        this.welcomeMessageTimer = setTimeout(() => {
            this.closeWelcomeMessage();
        }, 40000); // 40 segundos = 40000 milissegundos
    }

    ngOnDestroy() {
        // Limpa os timers ao destruir o componente
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        if (this.welcomeMessageTimer) {
            clearTimeout(this.welcomeMessageTimer);
        }
    }

    onMouseEnter() {
        if (!this.layoutService.layoutState().anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }

            this.layoutService.layoutState.update((state) => {
                if (!state.sidebarActive) {
                    return {
                        ...state,
                        sidebarActive: true
                    };
                }
                return state;
            });
        }
    }

    onMouseLeave() {
        if (!this.layoutService.layoutState().anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => {
                    this.layoutService.layoutState.update((state) => {
                        if (state.sidebarActive) {
                            return {
                                ...state,
                                sidebarActive: false
                            };
                        }
                        return state;
                    });
                }, 300);
            }
        }
    }

    anchor() {
        this.layoutService.layoutState.update((state) => ({
            ...state,
            anchored: !state.anchored
        }));
    }

    closeWelcomeMessage() {
        this.showWelcomeMessage = false;
        // Limpa o timer se a mensagem for fechada manualmente
        if (this.welcomeMessageTimer) {
            clearTimeout(this.welcomeMessageTimer);
            this.welcomeMessageTimer = null;
        }
    }

    onLearnMoreClick(event: Event) {
        event.preventDefault();
        window.open(this.sigosMvcUrl, '_blank');
    }
}
